var _path;

import * as React from "react";

function SvgExclamationBoldCircle(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4C11.164 4 4 11.167 4 20c0 8.838 7.164 16 16 16s16-7.162 16-16c0-8.833-7.164-16-16-16zm0 28.903c-7.131 0-12.903-5.77-12.903-12.903 0-7.129 5.772-12.903 12.903-12.903 7.128 0 12.903 5.772 12.903 12.903S27.133 32.903 20 32.903zm2.71-6.71a2.713 2.713 0 01-2.71 2.71 2.713 2.713 0 01-2.71-2.71 2.713 2.713 0 012.71-2.71 2.713 2.713 0 012.71 2.71zm-5.25-13.638l.439 8.774c.02.412.36.735.773.735h2.656a.774.774 0 00.773-.735l.439-8.774a.774.774 0 00-.773-.813h-3.534a.774.774 0 00-.773.813z"
  })));
}

export default SvgExclamationBoldCircle;